/**
 * Takes an object of constant defaults and allows first level comparisons to it.
 */
class DefaultsComparator {

    /** @type {Object} */
    _defaultStrings = {}

    /**
     * @param {Object} defaults
     */
    constructor(defaults) {
        for (const key in defaults) {
            this._defaultStrings[key] = JSON.stringify(defaults[key])
        }
        this.isDefault = this.isDefault.bind(this)
    }

    /**
     * @param {Object} object
     * @returns {boolean} Whether given object matches the defaults
     */
    isDefault(object) {
        for (const key in object) {
            if (JSON.stringify(object[key]) !== this._defaultStrings[key]) return false
        }
        return true
    }

}

export default DefaultsComparator
